<template>
  <span
    class="tw-pointer-events-none tw-rounded-lg tw-bg-gray-500 tw-px-2 tw-py-1 tw-text-sm tw-text-white tw-absolute tw--top-7 tw-right-0 tw-w-max tw-opacity-0 tw-transition-opacity tw-z-50"
    :class="{ 'tw-opacity-100': showTooltip }"
  >
    {{ textValue }}
  </span>
</template>
<script>
export default {
  props: {
    textValue: String,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  methods: {
    show() {
      this.showTooltip = true;
    },
    hide() {
      this.showTooltip = false;
    },
  },
};
</script>
